export default __webpack_public_path__ + "static/media/service-Data-Scientist-Analyst.022ce986.jpg";